module.exports = "/images/littlephone@2x.png?634961a11eb797f25a771bceefeea960";